/**
 * If mobile it opens the navigation as sidebar, when clicking somewhere else
 * when the sidebar is open it hides automatically.
 */

const getOffsetLeft = (el) => {
  const elOffset = el.getBoundingClientRect();

  const { body } = document;
  const docEl = document.documentElement;

  const scrollLeft = window.pageXOffset || docEl.scrollLeft || body.scrollLeft;

  const clientLeft = docEl.clientLeft || body.clientLeft || 0;

  const left = elOffset.left + scrollLeft - clientLeft;

  return left;
};

export default getOffsetLeft;
